<script setup lang="ts">
import { TicketStateValues } from "@telegraphio/bapi-types";
</script>

<template>
  <FormKit
    type="togglebuttons"
    name="state"
    label="Ticket status"
    :options="[TicketStateValues.UNASSIGNED, TicketStateValues.IN_PROGRESS, TicketStateValues.CLOSED]"
    multiple
    enforced
    :value="[TicketStateValues.UNASSIGNED, TicketStateValues.IN_PROGRESS]"
  />
</template>
